module.exports = dibs_buyer_layout;